export const fontPrimary5 = 'rgba(42, 76, 250, 1)'
export const placeholderBackgroundColor = 'rgba(4, 46, 255, 0.1)'
export const placeholderBackgroundColorOnHover = 'rgba(4, 46, 255, 0.3)'
